/* product-image-zoom.js — Stage 2: desktop hover zoom + mobile tap-to-zoom and drag-to-pan */
(function () {
  if (window.__pzLoaded) return;
  window.__pzLoaded = true;

  var SCALE = 2.5;
  var TAP_MAX_MS = 500;
  var TAP_MAX_MOVE = 8;

  var css = document.createElement('style');
  css.textContent =
    '.pz-wrap{display:block;overflow:hidden;}' +
    '.pz-wrap>img{display:block;transform-origin:0 0;transition:transform .15s ease-out;will-change:transform;height:auto;}' +
    '.pz-wrap.pz-zoomed{touch-action:none;}' +
    '.pz-wrap.pz-dragging>img{transition:none;}';
  document.head.appendChild(css);

  function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }

  // Set the image offset (px), clamped so no edge is ever out of reach
  function setPos(wrap, x, y) {
    var w = wrap.clientWidth, h = wrap.clientHeight;
    x = clamp(x, w * (1 - SCALE), 0);
    y = clamp(y, h * (1 - SCALE), 0);
    wrap.__x = x;
    wrap.__y = y;
    wrap.firstElementChild.style.transform =
      'translate(' + x + 'px,' + y + 'px) scale(' + SCALE + ')';
  }

  // px/py = pointer position inside the wrapper, 0..1
  function focusOn(wrap, px, py) {
    setPos(wrap,
      -px * (SCALE - 1) * wrap.clientWidth,
      -py * (SCALE - 1) * wrap.clientHeight);
  }

  function zoomIn(wrap) {
    var img = wrap.firstElementChild;
    wrap.classList.add('pz-zoomed');
    // Ask the browser for a larger srcset candidate so the zoom stays sharp
    if (!img.dataset.pzSized) {
      img.dataset.pzSized = '1';
      img.sizes = Math.ceil(SCALE * 100) + 'vw';
    }
  }

  function reset(wrap) {
    wrap.classList.remove('pz-zoomed', 'pz-dragging');
    wrap.firstElementChild.style.transform = '';
    wrap.__x = 0;
    wrap.__y = 0;
    wrap.__d = null;
  }

  function fraction(wrap, e) {
    var r = wrap.getBoundingClientRect();
    return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height];
  }

  function setup(modal) {
    if (modal.__pz) return;
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    modal.__pz = true;

    content.querySelectorAll('img[data-media-id]').forEach(function (img) {
      if (img.closest('deferred-media, product-model')) return;

      var wrap = document.createElement('div');
      wrap.className = 'pz-wrap';
      wrap.__x = 0;
      wrap.__y = 0;
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
            // Mirror the theme's "active" class onto the wrapper, because the theme
      // hides non-active direct children on mobile
      function syncActive() {
        wrap.classList.toggle('active', img.classList.contains('active'));
      }
      syncActive();
      new MutationObserver(syncActive).observe(img, { attributes: true, attributeFilter: ['class'] });

      /* ---------- Desktop: hover to zoom, move to pan ---------- */
      wrap.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        zoomIn(wrap);
        var f = fraction(wrap, e);
        focusOn(wrap, f[0], f[1]);
      });
      wrap.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !wrap.classList.contains('pz-zoomed')) return;
        var f = fraction(wrap, e);
        focusOn(wrap, f[0], f[1]);
      });
      wrap.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        reset(wrap);
      });

      /* ---------- Touch / pen: tap to toggle, drag to pan ---------- */
      wrap.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        wrap.__d = {
          id: e.pointerId,
          sx: e.clientX, sy: e.clientY,
          ox: wrap.__x || 0, oy: wrap.__y || 0,
          t: Date.now(),
          moved: false
        };
        if (wrap.classList.contains('pz-zoomed')) {
          try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
        }
      });

      wrap.addEventListener('pointermove', function (e) {
        var d = wrap.__d;
        if (!d || e.pointerType === 'mouse' || e.pointerId !== d.id) return;
        var dx = e.clientX - d.sx, dy = e.clientY - d.sy;
        if (!d.moved && Math.hypot(dx, dy) > TAP_MAX_MOVE) d.moved = true;
        if (d.moved && wrap.classList.contains('pz-zoomed')) {
          wrap.classList.add('pz-dragging');
          setPos(wrap, d.ox + dx, d.oy + dy);
        }
      });

      wrap.addEventListener('pointerup', function (e) {
        var d = wrap.__d;
        if (!d || e.pointerType === 'mouse' || e.pointerId !== d.id) return;
        wrap.__d = null;
        wrap.classList.remove('pz-dragging');
        if (d.moved || Date.now() - d.t > TAP_MAX_MS) return;
        if (wrap.classList.contains('pz-zoomed')) {
          reset(wrap);
        } else {
          zoomIn(wrap);
          var f = fraction(wrap, e);
          focusOn(wrap, f[0], f[1]);
        }
      });

      wrap.addEventListener('pointercancel', function () {
        wrap.__d = null;
        wrap.classList.remove('pz-dragging');
      });
    });

    // Always reopen un-zoomed
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        modal.querySelectorAll('.pz-zoomed').forEach(reset);
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('product-modal').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();